module.exports = __webpack_public_path__ + "static/media/500.5fb41a21.svg";